/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '..';

export const OperationDropdown = ({ label, id, onChange, value, allList = true }) => {

  const [ t ] = useTranslation();
  const OPERATION_DROPDOWN = {
    LABEL: 'Operation',
    ALL: null,
    ACCEPT: 101,
    BLOCK: 116,
    BLOCK_CANCEL: 117,
    BLOCK_CANCEL_AND_RECALL: 120,
    CHECK_STATUS: 108,
    CONSUME: 111,
    CONSUME_CANCEL: 112,
    DEACTIVATE: 106,
    DEACTIVATION_CANCEL: 124,
    DISPATCH: 103,
    DISPACH_ACCEPT: 125,
    DISPATCH_CANCEL: 104,
    EXPORT: 105,
    EXPORT_CANCEL: 113,
    IMPORT: 119,
    IMPORT_CANCEL: 123,
    PHARMACY_SALE: 109,
    PHARMACY_SALE_CANCEL: 110,
    RECALL: 118,
    RECALL_CANCEL: 121,
    RETURN: 102,
    SUPPLY: 100,
    SUPPLY_CANCEL: 122,
    TRANSFER: 114,
    TRANSFER_CANCEL: 115
  };

  return (
    <>
      { allList ? (
        <LabeledSelect
          label={ label }
          id={ id }
          onChange={ onChange }
          showSearch
          withDebounceSearch={ true }
          value={ value }
          options={ [
      {
        value: OPERATION_DROPDOWN.ALL,
        text: t('fields.operation.all') },
      {
        value: OPERATION_DROPDOWN.ACCEPT,
        text: t('fields.operation.accept')//
      },
      {
        value: OPERATION_DROPDOWN.BLOCK,
        text: t('fields.operation.block')
      },
      {
        value: OPERATION_DROPDOWN.BLOCK_CANCEL,
        text: t('fields.operation.blockCancel')
      },
      {
        value: OPERATION_DROPDOWN.BLOCK_CANCEL_AND_RECALL,
        text: t('fields.operation.blockCancelAndRecall')
      },
      {
        value: OPERATION_DROPDOWN.CHECK_STATUS,
        text: t('fields.operation.checkStatus')
      },
      {
        value: OPERATION_DROPDOWN.CONSUME,
        text: t('fields.operation.consume')//
      },
      {
        value: OPERATION_DROPDOWN.CONSUME_CANCEL,
        text: t('fields.operation.consumeCancel')//
      },
      {
        value: OPERATION_DROPDOWN.DEACTIVATE,
        text: t('fields.operation.deactivate')//
      },
      {
        value: OPERATION_DROPDOWN.DEACTIVATION_CANCEL,
        text: t('fields.operation.deactivationCancel')
      },
      {
        value: OPERATION_DROPDOWN.DISPATCH,
        text: t('fields.operation.dispatch')//
      },
      {
        value: OPERATION_DROPDOWN.DISPACH_ACCEPT,
        text: t('fields.operation.dispachAccept')
      },
      {
        value: OPERATION_DROPDOWN.DISPATCH_CANCEL,
        text: t('fields.operation.dispatchCancel')//
      },
      {
        value: OPERATION_DROPDOWN.EXPORT,
        text: t('fields.operation.export')//
      },
      {
        value: OPERATION_DROPDOWN.EXPORT_CANCEL,
        text: t('fields.operation.exportCancel')//
      },
      {
        value: OPERATION_DROPDOWN.IMPORT,
        text: t('fields.operation.import')//
      },
      {
        value: OPERATION_DROPDOWN.IMPORT_CANCEL,
        text: t('fields.operation.importCancel')
      },
      {
        value: OPERATION_DROPDOWN.PHARMACY_SALE,
        text: t('fields.operation.pharmacySale')//
      },
      {
        value: OPERATION_DROPDOWN.PHARMACY_SALE_CANCEL,
        text: t('fields.operation.pharmacySaleCancel')//
      },
      {
        value: OPERATION_DROPDOWN.RECALL,
        text: t('fields.operation.recall')
      },
      {
        value: OPERATION_DROPDOWN.RECALL_CANCEL,
        text: t('fields.operation.recallCancel')
      },
      {
        value: OPERATION_DROPDOWN.RETURN,
        text: t('fields.operation.return')//
      },
      {
        value: OPERATION_DROPDOWN.SUPPLY,
        text: t('fields.operation.supply')//
      },
      {
        value: OPERATION_DROPDOWN.SUPPLY_CANCEL,
        text: t('fields.operation.supplyCancel')
      },
      {
        value: OPERATION_DROPDOWN.TRANSFER,
        text: t('fields.operation.transfer')//
      },
      {
        value: OPERATION_DROPDOWN.TRANSFER_CANCEL,
        text: t('fields.operation.transferCancel') //
      }
          ] }
        />
      ) : (
        <LabeledSelect
          label={ label }
          id={ id }
          onChange={ onChange }
          showSearch
          withDebounceSearch={ true }
          value={ value }
          options={ [
      {
        value: OPERATION_DROPDOWN.ALL,
        text: t('fields.operation.all') },
      {
        value: OPERATION_DROPDOWN.ACCEPT,
        text: t('fields.operation.accept')//
      },
      {
        value: OPERATION_DROPDOWN.CONSUME,
        text: t('fields.operation.consume')//
      },
      {
        value: OPERATION_DROPDOWN.CONSUME_CANCEL,
        text: t('fields.operation.consumeCancel')//
      },
      {
        value: OPERATION_DROPDOWN.DEACTIVATE,
        text: t('fields.operation.deactivate')//
      },
      {
        value: OPERATION_DROPDOWN.DEACTIVATION_CANCEL,
        text: t('fields.operation.deactivationCancel')
      },
      {
        value: OPERATION_DROPDOWN.DISPATCH,
        text: t('fields.operation.dispatch')//
      },
      {
        value: OPERATION_DROPDOWN.DISPATCH_CANCEL,
        text: t('fields.operation.dispatchCancel')//
      },
      {
        value: OPERATION_DROPDOWN.EXPORT,
        text: t('fields.operation.export')//
      },
      {
        value: OPERATION_DROPDOWN.EXPORT_CANCEL,
        text: t('fields.operation.exportCancel')//
      },
      {
        value: OPERATION_DROPDOWN.IMPORT,
        text: t('fields.operation.import')//
      },
      {
        value: OPERATION_DROPDOWN.PHARMACY_SALE,
        text: t('fields.operation.pharmacySale')//
      },
      {
        value: OPERATION_DROPDOWN.PHARMACY_SALE_CANCEL,
        text: t('fields.operation.pharmacySaleCancel')//
      },
      {
        value: OPERATION_DROPDOWN.RETURN,
        text: t('fields.operation.return')//
      },
      {
        value: OPERATION_DROPDOWN.SUPPLY,
        text: t('fields.operation.supply')//
      },
      {
        value: OPERATION_DROPDOWN.TRANSFER,
        text: t('fields.operation.transfer')//
      },
      {
        value: OPERATION_DROPDOWN.TRANSFER_CANCEL,
        text: t('fields.operation.transferCancel') //
      }
          ] }
        />
      )
      }
    </>
  );
};
